import { useQuery } from '@apollo/client';
import { LenderPerformanceReportInput } from '@trnsact/trnsact-shared-types';
import {
  LenderApprovalTermsSummaryQueryResponse,
  LenderAverageRateByLenderQueryResponse,
  LenderTermDistributionByLenderQueryResponse,
  LenderTermsComparisonTableQueryResponse,
  LenderTotalCostComparisonQueryResponse,
} from '../api/types';
import { reportsApi } from '../api';
import { TERMS_COMPARISON_DEFAULT_SORTING } from '../constants';
import { ConversionTableSorting } from '../types';

export const useLenderPerformanceApprovalTerms = (
  input: LenderPerformanceReportInput,
  sorting: ConversionTableSorting = TERMS_COMPARISON_DEFAULT_SORTING
) => {
  const variables = { input };
  const context = { authRequired: true };

  const { data: summaryData, loading: isSummaryLoading } = useQuery<LenderApprovalTermsSummaryQueryResponse>(
    reportsApi.getLenderApprovalTermsSummary,
    { variables, context }
  );

  const { data: comparisonData, loading: isComparisonLoading } = useQuery<LenderTermsComparisonTableQueryResponse>(
    reportsApi.getLenderTermsComparisonTable,
    { context, variables: { input: { ...input, sorting } } }
  );

  const { data: averageRateData, loading: isAverageRateLoading } = useQuery<LenderAverageRateByLenderQueryResponse>(
    reportsApi.getLenderAverageRateByLender,
    { variables, context }
  );

  const { data: termDistributionData, loading: isTermDistributionLoading } =
    useQuery<LenderTermDistributionByLenderQueryResponse>(reportsApi.getLenderTermDistributionByLender, {
      variables,
      context,
    });

  const { data: totalCostData, loading: isTotalCostLoading } = useQuery<LenderTotalCostComparisonQueryResponse>(
    reportsApi.getLenderTotalCostComparison,
    { variables, context }
  );

  return {
    summary: summaryData?.lenderPerformance?.approvalTermsSummary?.entity ?? null,
    comparison: comparisonData?.lenderPerformance?.termsComparisonTable?.entity ?? [],
    averageRate: averageRateData?.lenderPerformance?.averageRateByLender?.entity ?? [],
    termDistribution: termDistributionData?.lenderPerformance?.termDistributionByLender?.entity ?? [],
    totalCost: totalCostData?.lenderPerformance?.totalCostComparison?.entity ?? [],
    isSummaryLoading,
    isComparisonLoading,
    isAverageRateLoading,
    isTermDistributionLoading,
    isTotalCostLoading,
  };
};
